<!-- 城管 -->
<template>
    <div class="data-statistics">
        <div class="data-zitem" :class="index === activity ? 'data-bg-activity' : 'data-bg'"
            v-for="(item, index) in dataList" :key="item.id" @click="bindData(item, index)">
            <Icon-svg class="data-zitem-img" :name="item.url" />
            <div class="data-zitem-value">
                <div class="data-zitem-title">
                    {{ item.name }}
                </div>
                <div class="data-zitem-num">
                    {{ item.value }}
                    <span class="data-zitem-unit">{{ item.unit }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        dataList: Array,
        currentIndex: { // 当前选中的下标，支持.sync修饰符，用于双向绑定当前选中的下标
            type: Number,
            default: -1,
        },
    },

    data() {
        return {
            activity: this.currentIndex,
        };
    },
    computed: {},
    methods: {
        bindData(item, index) {
            // this.activity = item.id;
            this.activity = index;
            this.$emit('update:currentIndex', index);
            this.$emit('bindData', item);
            this.$emit('change', { data: item, index });
        },
    },
    watch: {
        // dataList() { },
        // activity() { },
    },
    mounted() { },
};
</script>

<style lang="scss" scoped>
.data-statistics {
    display: flex;
    justify-content: space-between;

    .data-zitem {
        display: flex;
        width: 145px;
        height: 56px;
        position: relative;
        margin: 0 0px;

        .data-zitem-img {
            width: 35px;
            height: 35px;
            margin: 10.5px 5px;
        }

        .data-zitem-value {
            color: white;
            text-align: center;
            width: 90px;

            .data-zitem-title {
                font-size: 14px;
                margin-top: 6px;
                margin-bottom: 12px;
            }

            .data-zitem-unit {
                font-size: 12px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
            }

            .data-zitem-num {
                font-weight: bold;
                font-size: 18px;
                color: #ffffff;
                margin-top: 5px;
            }
        }
    }

    .data-bg {
        background-image: url('images/data-bg.png');
        background-size: 100% 100%;
    }

    .data-bg-activity {
        background-image: url('images/data-bg-activity.png');
        background-size: 100% 100%;
    }
}
</style>
